<template lang='pug'>
  v-container(grid-list-md fluid style="overflow:hidden;")
    div(class="text-xs-right" v-if="chip")
      v-chip(close @input="clearFilters" style="margin-bottom: -65px") Limpar Filtros
    material-card(color="amber" title="Empresas")
      template(slot="header" v-if="profile === 'administrator'")
        v-btn(color='success' to='/company') novo
      template(slot="tools")
        v-text-field(
          v-model="search"
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
        )
        v-spacer
      v-data-table(
        :headers='headers'
        :items='items'
        :loading="loading"
        :pagination.sync="pagination"
        :search="search"
      )
        template(v-slot:items='props')
          td.text-xs-center
            v-tooltip(bottom v-if="props.item.disabled")
              template(v-slot:activator="{ on }")
                v-icon(v-on="on" color="") remove_circle
              span Parceiro bloqueado
            div(v-else)
              v-tooltip(bottom v-if="props.item.integrations && props.item.integrations.contaAzul && props.item.integrations.contaAzul.customerId")
                template(v-slot:activator="{ on }")
                  v-icon(v-on="on") assignment_ind
                span Cliente criado no faturamento
              v-tooltip(bottom v-if="props.item.integrations && props.item.integrations.contaAzul && props.item.integrations.contaAzul.contractId")
                template(v-slot:activator="{ on }")
                  v-icon(v-on="on") assignment_turned_in
                span Contrato criado no dia {{ props.item.integrations.contaAzul.contractEmission | date }}
              v-tooltip(bottom v-if="props.item.integrations && props.item.integrations.error")
                template(v-slot:activator="{ on }")
                  v-icon(v-on="on" color="error") assignment_late
                span {{ props.item.integrations.error }}
          td {{ props.item.name }}
          td {{ props.item.cnpj | cnpj }}
          td {{ props.item.email }}
          td {{ props.item.phone | phone }}
          td {{ props.item.info }}
          td.text-xs-center
            v-tooltip(bottom v-show="true")
              template(v-slot:activator="{ on }")
                v-btn(icon v-on="on" :to='"company/" + props.item.iuid')
                  v-icon(color='tertiary' ) edit
              span Editar Empresa
            v-tooltip(bottom)
              template(v-slot:activator="{ on }")
                v-btn(icon v-on="on" @click='onRemove(props.item.iuid)')
                  v-icon(color='error' ) delete
              span Deletar Empresa
            v-tooltip(bottom)
              template(v-slot:activator="{ on }")
                v-btn(icon v-on="on" @click='RemoveCompanyNewCustomer(props.item.iuid)')
                  v-icon(color='error' ) group_remove
              span Deletar Clientes Novos
            v-tooltip(bottom)
              template(v-slot:activator="{ on }")
                v-btn(icon v-on="on" @click='RemoveCompanyCustomerData(props.item.iuid)')
                  v-icon(color='error' ) delete_forever
              span Deletar Todos os Clientes

</template>

<script>
import { db, functionsSP } from '@/store/firebase'
import firestoreUtils from '@/utils/firestore'
import { mapGetters } from 'vuex'
import { unsubscribe } from '../../utils/unsubscribe'
import { filterPage } from '../../utils/filters-page'

export default {
  name: 'companies',

  data() {
    return {
      headers: [
        { text: 'Status', value: 'disabled' },
        { text: 'Nome', value: 'name' },
        { text: 'CNPJ', value: 'cnpj' },
        { text: 'Email', value: 'email' },
        { text: 'Telefone', value: 'phone' },
        { text: 'Informações', value: 'info' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'center' }
      ],
      items: [],
      loading: false,
      pagination: {},
      chip: false,
      done: false,
      search: ''
    }
  },

  computed: {
    ...mapGetters(['profile'])
  },

  watch: {
    'pagination'(val) {
      if (this.done && Object.entries(this.pagination).length > 0) {
        filterPage.save('companies', val)
        this.chip = true
      }
    }
  },

  mounted() {
    this.getCompanies()
  },

  destroyed() {
    unsubscribe('companies')
  },

  methods: {
    onRemove(id) {
      this.alertConfirmRemove(() => {
        return db.collection('companies')
          .doc(id)
          .delete()
          .then(() => {
            // console.info('Removido Company -> ' + id)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },

    RemoveCompanyCustomerData(id) {
      this.alertConfirmRemove(() => {
        return functionsSP.httpsCallable('clearCustomers')({ companyId: id, status: 'ALL_CUSTOMER' })
          .then(() => {
            // console.info('Removido Company -> ' + id)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },

    RemoveCompanyNewCustomer(id) {
      this.alertConfirmRemove(() => {
        return functionsSP.httpsCallable('clearCustomers')({ companyId: id, status: 'NOVO' })
          .then(() => {
            return functionsSP.httpsCallable('clearCustomers')({ companyId: id, status: 'CAMPANHA' })
          })
          .catch(err => {
            console.log(err)
          })
      })
    },

    clearFilters() {
      this.pagination = {}
      filterPage.remove('companies')
      this.chip = false
    },

    getCompanies() {
      this.$Progress.start()
      this.loading = true
      db.collection('companies').onSnapshot(payload => {
        if (payload.empty) this.items = []
        else {
          this.items = payload.docs.map(item =>
            firestoreUtils.docToObject(item)
          )
          const filter = filterPage.get('companies', true)
          if (filter && Object.entries(filter).length > 0) {
            this.pagination = filter
          }
        }
        this.loading = false
        this.done = true
        this.$Progress.finish()
      })
    }
  }
}
</script>

<style lang='stylus' scoped></style>
